import React, { useState } from 'react';
import NavBar from '../../layout/NavBar';
import NavBarBot from '../../layout/NavBarBot';
import { Container, Box, ThemeProvider } from '@mui/material';
import { darkTheme } from '../../../theme/darkTheme';
import { calc1RM } from './components/onerepmax/oneRepMaxUtils';
import EingabeKarte from './components/onerepmax/EingabeKarte';
import ErgebnisKarte from './components/onerepmax/ErgebnisKarte';

export default function OneRepMaxCalc() {
    const [weight, setWeight] = useState('');
    const [reps, setReps] = useState('');
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');

    const handleCalc = () => {
        const w = parseFloat(weight);
        const r = parseInt(reps);
        if (!w || !r || w <= 0 || r <= 0 || r > 30) {
            setError('Bitte gültige Werte eingeben (Wdh. 1–30).');
            return;
        }
        setError('');
        const res = calc1RM(w, r);
        setResult({ orm: res, weight: w, reps: r });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleCalc();
    };

    return (
        <ThemeProvider theme={darkTheme}>
            <Box
                sx={{
                    bgcolor: 'background.default',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    pb: 4,
                }}
            >
                <NavBar />
                <Container
                    maxWidth={false}
                    sx={{
                        pt: 2,
                        px: 2,
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    }}
                >
                    <EingabeKarte
                        weight={weight}
                        reps={reps}
                        onWeight={setWeight}
                        onReps={setReps}
                        onKeyDown={handleKeyDown}
                        onCalc={handleCalc}
                        error={error}
                    />

                    {result && <ErgebnisKarte result={result} />}
                </Container>
            </Box>
            <NavBarBot />
        </ThemeProvider>
    );
}
